export const BREADCRUMB_SEGMENTS = [
    { pattern: 'discipline/*', labelGetter: 'getDisciplineName', fallbackLabel: 'Disciplina', to: 'discipline/*/materials' },
    { pattern: 'discipline/*/class', label: 'Turma' },
    { pattern: 'discipline/*/grades', label: 'Notas' },
    { pattern: 'discipline/*/materials/*/quiz', label: 'Questionário' },
    { pattern: 'discipline/*/materials/*/quiz/attempt/*/feedback', label: 'Feedback' },
    { pattern: 'discipline/*/materials/*/quiz/answers', label: 'Tentativas' },
    { pattern: 'discipline/*/materials/*/quiz/attempt/*', label: 'Tentativa', hiddenWhenBefore: 'Feedback' },
    { pattern: 'discipline/*/materials/assignment/*', label: 'Tarefa', to: 'discipline/*/materials/assignment/*/management' },
    { pattern: 'discipline/*/materials/assignment/*/attempt/*', label: 'Tentativa' },
    { pattern: 'discipline/*/assigment/*', label: 'Tarefa', to: 'discipline/*/materials/assignment/*/management' },
    { pattern: 'discipline/*/assigment/*/overview', label: 'Tentativas' },
    { pattern: 'discipline/*/assigment/*/feedback/*', label: 'Feedback' },
    { pattern: 'profile/*', label: 'Perfil' },
    { pattern: 'profile/*/settings', label: 'Configurações' },
];
const DEFAULT_HOME = '/my/disciplines';
const HOME_ROUTES = {
    admin: '/home',
    manager: '/disciplines',
};
function patternToRegex(pattern) {
    const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\\*/g, '[^/]+');
    return new RegExp(`^${escaped}$`);
}
function splitPathSegments(path) {
    return path.split('/').filter(Boolean);
}
function buildPatternPrefix(defSegments, endIndex) {
    return defSegments.slice(0, endIndex + 1).map(s => s.startsWith(':') ? '*' : s).join('/');
}
function findMatchingSegment(pattern) {
    return BREADCRUMB_SEGMENTS.find(seg => patternToRegex(seg.pattern).test(pattern));
}
function resolveLabel(entry, store) {
    if (entry.labelGetter) {
        return store.getters[entry.labelGetter] || entry.fallbackLabel || entry.label || '';
    }
    return entry.label || '';
}
function resolveLink(entry, realSegments, defSegments, endIndex) {
    if (!entry.to) {
        return '/' + realSegments.slice(0, endIndex + 1).join('/');
    }
    const paramValues = realSegments.filter((_, idx) => defSegments[idx]?.startsWith(':'));
    let paramIdx = 0;
    const resolved = entry.to.replace(/\*/g, () => paramValues[paramIdx++] || '*');
    return '/' + resolved;
}
export function getHomeRoute(store) {
    const role = store.getters.getType;
    return HOME_ROUTES[role] || DEFAULT_HOME;
}
export function buildBreadcrumbs(route, store) {
    const matched = route.matched[route.matched.length - 1];
    const pathDef = matched?.path || route.path;
    const defSegments = splitPathSegments(pathDef);
    const realSegments = splitPathSegments(route.path);
    const crumbs = [];
    const entries = [];
    for (let i = 0; i < defSegments.length; i++) {
        const pattern = buildPatternPrefix(defSegments, i);
        const entry = findMatchingSegment(pattern);
        if (!entry)
            continue;
        entries.push({
            entry,
            label: resolveLabel(entry, store),
            to: resolveLink(entry, realSegments, defSegments, i),
        });
    }
    for (let i = 0; i < entries.length; i++) {
        const { entry, label, to } = entries[i];
        const next = entries[i + 1];
        if (entry.hiddenWhenBefore && next?.label === entry.hiddenWhenBefore)
            continue;
        crumbs.push({ label, to });
    }
    return crumbs;
}
